import { IconButton, Grid, Paper, Dialog, DialogTitle, DialogContent, Button, DialogActions, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import ErrorIcon from "@mui/icons-material/Error";
import WarningIcon from "@mui/icons-material/Warning";
import WebIcon from "@mui/icons-material/Web";
import { observer } from "mobx-react";
import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { DELETABLE_TYPES, FileState } from "../../dto";
import { StoreContext } from "../../StoreContext";
import Tooltip from "@mui/material/Tooltip";
import DeleteIcon from "@mui/icons-material/Delete";
import styled from "@emotion/styled";
const Styled_Button = styled(IconButton)(({ theme }) => ({
    padding: "6px",
}));
const Styled_Typography = styled(Typography)(({ theme }) => ({
    fontWeight: 1000,
}));
const JobPanel = observer((props) => {
    const context = useContext(StoreContext);
    const [t, i18n] = useTranslation();
    const [errorMsgOpen, setErrorMsgOpen] = useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const renderStateIcon = (panelEntry) => {
        if (panelEntry == null) {
            return React.createElement(React.Fragment, null);
        }
        else if (panelEntry.state == FileState.WARNING) {
            return React.createElement(WarningIcon, { style: { color: "var(--clr-orange)" } });
        }
        else if (panelEntry.state == FileState.SUCCESS) {
            return (React.createElement(Styled_Button, { disabled: true },
                React.createElement(CheckIcon, { style: { color: "var(--clr-green)" } })));
        }
        else if (panelEntry.state == FileState.ERRROR) {
            return (React.createElement(Tooltip, { title: t("translations:msg validation error in data"), arrow: true, open: errorMsgOpen, onClose: () => setErrorMsgOpen(false), onOpen: () => setErrorMsgOpen(true), enterDelay: 700, enterNextDelay: 700, disableFocusListener: true, disableHoverListener: true, disableTouchListener: true },
                React.createElement(Styled_Button, { onClick: () => setErrorMsgOpen(!errorMsgOpen) },
                    React.createElement(ErrorIcon, { style: { color: "var(--clr-red)" } }))));
        }
        else {
            return React.createElement(React.Fragment, null);
        }
    };
    const renderSelectionButton = (panelEntry) => {
        if (panelEntry == null || panelEntry.state == FileState.MISSING) {
            return React.createElement(React.Fragment, null);
        }
        else {
            return (React.createElement(Styled_Button, { onClick: () => {
                    const history = context.rootStore.hashHistory;
                    if (history) {
                        history.push("/" + props.jobPanel.id + "_" + panelEntry.id);
                    }
                    context.rootStore.jobPanelStore.setSelectedEntry(panelEntry, props.jobPanel.id);
                } },
                React.createElement(WebIcon, null)));
        }
    };
    const renderDeleteButton = (panelEntry) => {
        if (panelEntry == null || !DELETABLE_TYPES.includes(panelEntry.type)) {
            return React.createElement(React.Fragment, null);
        }
        else {
            return (React.createElement(React.Fragment, null,
                React.createElement(Styled_Button, { onClick: () => {
                        setDeleteDialogOpen(true);
                    } },
                    React.createElement(DeleteIcon, null)),
                React.createElement(Dialog, { open: deleteDialogOpen, onClose: () => setDeleteDialogOpen(false) },
                    React.createElement(DialogTitle, null, t("translations:action delete entry")),
                    React.createElement(DialogContent, null,
                        React.createElement(Typography, { variant: "body1" }, t("translations:info delete entry"))),
                    React.createElement(DialogActions, null,
                        React.createElement(Button, { autoFocus: true, color: "primary", onClick: () => setDeleteDialogOpen(false), variant: "contained" }, t("translations:action cancel")),
                        React.createElement(Button, { variant: "contained", color: "primary", onClick: () => {
                                context.rootStore.jobPanelStore.deleteJobPanelEntry(props.jobPanel.id);
                                setDeleteDialogOpen(false);
                            } }, t("translations:action confirm"))))));
        }
    };
    const renderParameter = (label, value) => {
        return (React.createElement(Grid, { item: true, container: true, spacing: 1 },
            React.createElement(Grid, { item: true },
                React.createElement(Styled_Typography, { variant: "body1" }, label)),
            React.createElement(Grid, { item: true },
                React.createElement(Typography, { variant: "body1" }, value))));
    };
    const renderFileState = (type, entryType) => {
        const entry = entryType.entry;
        return (React.createElement(Grid, { item: true, container: true, spacing: 1, key: "jobPanelEntry_" + type, alignItems: "center" },
            React.createElement(Grid, { item: true },
                React.createElement(Styled_Typography, { variant: "body1" }, entryType.caption)),
            React.createElement(Grid, { item: true },
                React.createElement(Typography, { variant: "body1" }, entry != null ? entry.name : null)),
            React.createElement(Grid, { item: true },
                renderStateIcon(entry),
                renderSelectionButton(entry),
                renderDeleteButton(entry))));
    };
    const renderType = () => {
        const type = props.jobPanel.key.type;
        if (type == "keyDate") {
            const keyDate = props.jobPanel.key.keyDate;
            return renderParameter(t("translations:label keydate"), keyDate);
        }
        else if (type == "global") {
            return renderParameter(t("translations:label key global"), "");
        }
        else {
            return renderParameter("<INVALID TYPE>", type);
        }
    };
    return (React.createElement(Paper, { elevation: 3, style: { padding: "5px", backgroundColor: props.backgroundColor } },
        React.createElement(Grid, { container: true, spacing: 0, justifyContent: "space-between" },
            React.createElement(Grid, { item: true, container: true, xs: 5 },
                React.createElement(Grid, { item: true, xs: 12 }, renderType()),
                React.createElement(Grid, { item: true, xs: 12 }, renderParameter(t("translations:label last modified"), props.jobPanel.lastChangeTimeReadable))),
            React.createElement(Grid, { item: true, container: true, xs: 7 }, Object.keys(props.jobPanel.jobPanelEntries).map((type) => renderFileState(type, props.jobPanel.jobPanelEntries[type]))))));
});
export default JobPanel;
